export const serviceTypes: { value?: string; name: string }[] = [
  { value: 'REST', name: 'REST' },
  { value: 'External', name: 'External' },
  { value: 'SOAP', name: 'SOAP' },
  { value: 'DB2', name: 'DB2' },
  { value: 'MQ', name: 'MQ' },
];

export const ACTIVE = 'ACTIVE';
